import colors from "core/resources/theme/colors";
import styled, { createGlobalStyle } from "styled-components";

export const Container = styled.div<any>`
  width: 100%;
  .ant-select-focused:not(.ant-select-disabled).ant-select:not(
      .ant-select-customize-input
    )
    .ant-select-selector,
  .ant-select-selector:hover {
    box-shadow: 0 0 0 2px
      ${(props) => (props.isInvalid ? colors.red : colors.primary)} !important;
    outline-color: ${(props) =>
      props.isInvalid ? colors.red : colors.primary} !important;
  }

  .ant-select:not(.ant-select-customize-input) .ant-select-selector {
    background-color: ${(props) =>
      props.isInvalid ? colors.red100 : props.bg || colors.blue100} !important;
  }

  .ant-select-selector {
    border: 1px solid
      ${(props) => (props.isInvalid ? colors.red : colors.blue100)} !important;
    border-radius: 6px !important;
  }

  .ant-select:not(.ant-select-customize-input) .ant-select-selector {
    background-color: ${(props) =>
      props.isInvalid ? colors.red100 : props.bg || colors.blue100} !important;
  }

  .ant-select-multiple {
    .ant-select-selection-item {
      border: 1px solid ${colors.primary} !important;
      border-radius: 10px !important;
      font-size: 13px !important;
      height: 30px !important;
      line-height: 30px !important;
    }

    .ant-select-selection-item-remove {
      margin-top: -2px;
    }
  }

  .ant-select-selection-item,
  .ant-select-selection-placeholder {
    font-size: 13px !important;
    color: ${colors.black900} !important;
  }
`;

export const Global = createGlobalStyle<any>`

  .ant-select-item-option-selected:not(.ant-select-item-option-disabled) {
      background-color: ${colors.primary} !important;
      color: ${colors.white} !important;
    }
  
`;
